import { render, staticRenderFns } from "./BaseFAQQ.vue?vue&type=template&id=4aba064a&scoped=true&"
import script from "./BaseFAQQ.vue?vue&type=script&lang=js&"
export * from "./BaseFAQQ.vue?vue&type=script&lang=js&"
import style0 from "./BaseFAQQ.vue?vue&type=style&index=0&id=4aba064a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aba064a",
  null
  
)

export default component.exports